module.exports = __webpack_public_path__ + "static/screen-pushit-3-8bbd42fe1e54b4bcc041bbdcb8ae62d1.jpg";